import { render, staticRenderFns } from "./ItemExchangedDiscrepancy.vue?vue&type=template&id=c5c8f2fa&"
import script from "./ItemExchangedDiscrepancy.vue?vue&type=script&lang=js&"
export * from "./ItemExchangedDiscrepancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports